export default "__VITE_ASSET__uTnBlcQd__"